export default "__VITE_ASSET__DyD77VOK__"